import {
  Box,
  Center,
  CenterProps,
  CircularProgress,
  Text
} from '@chakra-ui/react'

export default function LoadingScreen({
  loadingText,
  fullScreen,
  bgProps
}: {
  loadingText?: string
  fullScreen?: boolean
  bgProps?: CenterProps
}) {
  return (
    <Center
      bg={'blue.50'}
      h={fullScreen ? '100vh' : '100%'}
      w="100%"
      textAlign={'center'}
      {...bgProps}
    >
      <Box>
        <CircularProgress isIndeterminate size="120px" color="blue.300" />
        {loadingText && <Text mt={2}>{loadingText}</Text>}
      </Box>
    </Center>
  )
}
